var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoBlackCon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40003264_8846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 12.9135C11.6816 12.9135 14.6663 10.3581 14.6663 7.20575C14.6663 4.05344 11.6816 1.49799 7.99967 1.49799C4.31778 1.49799 1.33301 4.05344 1.33301 7.20575C1.33301 10.3581 4.31778 12.9135 7.99967 12.9135Z",
    stroke: "#1F1F1F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9.48886V7.20575",
    stroke: "#1F1F1F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4.92267H8.00667",
    stroke: "#1F1F1F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40003264_8846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 13.6986,
    fill: "white",
    transform: "translate(0 0.356445)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlackCon);
export default __webpack_public_path__ + "static/media/info-black-con.e30bc2cc96f96b212cfbb436c94cdf6a.svg";
export { ForwardRef as ReactComponent };